module.exports = __webpack_public_path__ + "img/explore_header.b4fb36a9.png";